import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {StreamupComponent} from './streamup.component';
import {SmsComposeComponent} from './sms-center/sms-compose.component';
import {StreamupRoutingModule} from './streamup-routing.module';
import {MaxCharactersPipe} from '../pipes/max-characters.pipe';
import {WebsitePromosComponent} from './website-control-center/promotions/website-promos.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {MySitesComponent} from './website-control-center/my-sites/my-sites.component';
import {WhmcsComponent} from './whmcs/whmcs.component';
import {InlineSVGModule} from 'ng-inline-svg';
import { MatDialogModule } from '@angular/material/dialog';
import {DialogNewSiteComponent} from './website-control-center/my-sites/dialogs/dialog-new-site/dialog-new-site.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {MatButtonModule} from '@angular/material/button';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatIconModule} from '@angular/material/icon';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {DialogErrorComponent} from '../dialogs/dialog-error/dialog-error.component';
import {DialogQuickSmsComponent} from './whmcs/dialogs/dialog-quick-sms/dialog-quick-sms.component';
import {DialogClientDetailsComponent} from './whmcs/dialogs/dialog-client-details/dialog-client-details.component';
import {DialogConfirmationComponent} from '../dialogs/dialog-confirmation/dialog-confirmation.component';
import {DialogNewPromotionComponent} from './website-control-center/promotions/dialogs/dialog-new-promotion/dialog-new-promotion.component';
import {MatTabsModule} from '@angular/material/tabs';
import {Html5playersComponent} from './html5players/html5players.component';
import {AboutComponent} from './about/about.component';
import {UnderDevelopmentComponent} from './under-development/under-development.component';
import {DialogPredefinedSmsComponent} from './sms-center/dialogs/dialog-predefined-sms/dialog-predefined-sms.component';
import {VultrComponent} from './vultr/vultr.component';

@NgModule({
  declarations: [
      StreamupComponent,
      DashboardComponent,
      SmsComposeComponent,
      Html5playersComponent,
      VultrComponent,
      DialogClientDetailsComponent,
      DialogPredefinedSmsComponent,
      WhmcsComponent,
      WebsitePromosComponent,
      MySitesComponent,
      DialogNewSiteComponent,
      DialogQuickSmsComponent,
      DialogErrorComponent,
      DialogConfirmationComponent,
      DialogNewPromotionComponent,
      UnderDevelopmentComponent,
      AboutComponent,
      MaxCharactersPipe
  ],
    imports: [
        CommonModule,
        StreamupRoutingModule,
        InlineSVGModule,
        FormsModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatDialogModule,
        MatSnackBarModule,
        MatInputModule,
        MatButtonModule,
        MatCheckboxModule,
        MatSelectModule,
        MatIconModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatTabsModule
    ],
    // exports: [MatFormFieldModule, MatInputModule],
    entryComponents: [
        DialogNewSiteComponent,
        DialogQuickSmsComponent,
        DialogClientDetailsComponent,
        DialogNewPromotionComponent,
        DialogErrorComponent,
        DialogConfirmationComponent,
        DialogPredefinedSmsComponent
    ],
})
export class StreamupModule {}
